/*jshint esversion: 6 */
import React, { Component } from 'react';
 import '../css/utils.css';
 import '../css/MobileMenu.css';

class MobileMenu extends Component {

  constructor(props){
    super(props);
    this.state = {
      isMobileToggleOn: false
    };
    this.renderMobileMenu = this.renderMobileMenu.bind(this);
    this.sendClicku = this.sendClicku.bind(this);
  }

  sendClicku(ss, evt){
    console.log('sendClicku ss, evt', ss, evt);
    this.props.onClick(ss);
  }

  renderMobileMenu(){
    let pagetitles = this.props.pagetitles;
    let menuRows =[];
    if(pagetitles){
      if(pagetitles.length){
        pagetitles.map(((theme, k) => {
          menuRows.push(
              <button key={'mm' +k}  className="main_menu_item"  
                    onClick={() =>this.sendClicku(theme.link)}>
                    <span className="align_text">{theme.parent}</span>
              </button>
          );
              
          {theme.subpages.map((sub, si) => {
            menuRows.push(
              <button key={'sm' + si + k}  className="sub_menu_item"
                      onClick={() =>this.sendClicku(sub.link)}>
                    <span className="align_text">{sub.title}</span>
              </button>
            );
            })
          }
        }));
      }
    }
    return menuRows;
  }


    render() {
      //console.log("IS Mobile Visible? ", this.props.isMobileMenuVisible);
      const visibilityClassName = (this.props.isMobileMenuVisible)? 
      "mobile_menu_container" : "mobile_menu_container_invisible";
      const menurows = this.renderMobileMenu();
      return (
        <div className={visibilityClassName}>
            {menurows}
        </div>
      );
    }

}
  
  export default MobileMenu;


// WEBPACK FOOTER //
// ./src/Components/MobileMenu.js